import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { devLog } from '../devLog';
import Mixpanel from '../../lib/mixpanel';
import CustomerIO from '../../lib/customerio';
import { useCurrentRoute } from './useCurrentRoute';

/**
 * Track a page view with both GA and mixpanel
 */
export const usePageViews = () => {
  const currentRoute = useCurrentRoute();
  const location = useLocation();
  const pathWithSearch = `${location.pathname}${location.search}`;

  // Track page visit whenever location changes
  useEffect(() => {
    if (currentRoute?.path && currentRoute.path !== '*') {
      // if the route is not the not found route
      // Track mixpanel. The mixpanel tracker has its own dev mode handling
      Mixpanel.track(`Page view - ${currentRoute.path.substring(1)}`, {
        pathname: currentRoute.path,
      });
    }

    CustomerIO.page(pathWithSearch);

    if (!import.meta.env.VITE_NODE_ENV || import.meta.env.VITE_NODE_ENV !== 'production') {
      // Don't track in dev mode
      devLog('tracking', '- NOT tracking page view');
    } else {
      devLog('tracking', 'page view');

      ReactGA.send('pageview');
    }
  }, [currentRoute?.path, pathWithSearch]);
};
